import styled from '@emotion/styled'

export const Lists = styled.div`
  margin: 20px 0;
`
